import { PropsWithChildren, useEffect, useState } from "react";
import { appInsights } from "./ApplicationInsightsService";
import useCookies from "hooks/useCookies";

type CPLAnalyticsProps = {
  pageName?: string;
  children: React.ReactNode;
};

const CPLAnalytics: React.FC<PropsWithChildren<CPLAnalyticsProps>> = ({ pageName: componentName, children }) => {
  const [analyticsAllowed, setAnalyticsAllowed] = useState(false);
  const { preferences } = useCookies();

  useEffect(() => {
    const analyticsAllowed = preferences?.analyticsEnabled ?? false;
    setAnalyticsAllowed(analyticsAllowed);
    appInsights.getCookieMgr().setEnabled(analyticsAllowed);
  }, [preferences?.analyticsEnabled]);

  if (analyticsAllowed) {
    appInsights.trackPageView({ name: componentName });
  }

  return <>{children}</>;
};

export { CPLAnalytics };
